import { FC, useEffect } from 'react';
import moment from 'moment';
import { DatePicker } from 'antd';
import { useSelector } from 'react-redux';
import { RootState } from '../store/rootReducer';
import _ from 'lodash';
import { RangePickerProps } from 'antd/es/date-picker';
import { INotificationItem } from '../models/notification.model';

interface IProps {
  startDate: string;
  notificationItemList: INotificationItem[];

  onStartDateChange(value: string): void;
}

const StartClassDatePicker: FC<IProps> = ({
  startDate,
  notificationItemList,
  onStartDateChange,
}) => {
  const { serverDate } = useSelector((state: RootState) => state.serverDate);

  const disabledDate: RangePickerProps['disabledDate'] = (current) => {
    return !Boolean(
      notificationItemList?.find(
        ({ timetableDate }) => current.format('YYYYMMDD') === timetableDate,
      ),
    );
  };

  useEffect(() => {
    if (serverDate) {
      const _notificationItemList = _.cloneDeep(notificationItemList).sort(
        (a, b) =>
          a.timetableDate < b.timetableDate
            ? -1
            : a.timetableDate > b.timetableDate
            ? 1
            : 0,
      );

      for (let i = 0; i < _notificationItemList.length; i++) {
        if (
          moment(serverDate).isBefore(_notificationItemList[i].timetableDate)
        ) {
          onStartDateChange(_notificationItemList[i].timetableDate);
          break;
        }
      }
    }
  }, [notificationItemList, serverDate]);

  return (
    <div className="date-picker__area">
      <DatePicker
        value={startDate ? moment(startDate) : undefined}
        onChange={(e) => {
          if (e === null) onStartDateChange('');
          else onStartDateChange(moment(e).format('YYYYMMDD'));
        }}
        disabledDate={disabledDate}
      />
    </div>
  );
};

export default StartClassDatePicker;
